import { AxiosError } from 'axios'
import { LuigiClient } from './base-clients/luigi'
import { ok, err, Result } from 'neverthrow'
import { ExpertsClient } from './base-clients/experts.client'

type FileUploadApiResponseType = {
    data: {
        [key: string]: {
            download_url: string
            upload_url: string
            expiry: string
        }
    }
}

export const getSignedURLSApi = async (path: string): Promise<Result<string, AxiosError>> => {
    try {
        const resp = await LuigiClient.post(
            `api/v1/signed-urls`,
            {
                paths: [
                    {
                        path,
                        expiry: 86400,
                    },
                ],
            },
            {
                headers: {
                    'x-vault-key': 'fts-data',
                },
            }
        )
        return ok(resp.data.data[path].download_url)
    } catch (e) {
        return err(e as AxiosError)
    }
}

export const getSignedURLSByPathAPI = async (
    path: string
): Promise<Result<FileUploadApiResponseType, AxiosError>> => {
    try {
        const resp = await ExpertsClient.post(`v1/internal-view/get-signed-urls`, {
            paths: [path],
        })
        return ok(resp.data)
    } catch (e) {
        return err(e as AxiosError)
    }
}
